import { render, staticRenderFns } from "./HistoryItem.vue?vue&type=template&id=aeb5aff0"
import script from "./HistoryItem.vue?vue&type=script&lang=js"
export * from "./HistoryItem.vue?vue&type=script&lang=js"
import style0 from "./HistoryItem.vue?vue&type=style&index=0&id=aeb5aff0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports